import axios from 'axios';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';
import * as utils from '../../utils/Utils';

let fetchChangeLogsCancelToken: AbortController | null = null;
let fetchChangeLogItemsCancelToken: AbortController | null = null;

export interface FetchChangeLogsHistoryParams {
  page?: number;
  limit?: number;
  brand_ids?: number[];
  item_ids?: number[];
  segments?: string[];
  log_user_ids?: number[];
}

export function fetchChangeLogsHistory({
  page = 1,
  limit = utils.getPageLimit(),
  brand_ids,
  item_ids,
  segments,
  log_user_ids,
}: FetchChangeLogsHistoryParams = {}) {
  if (fetchChangeLogsCancelToken) fetchChangeLogsCancelToken.abort();

  fetchChangeLogsCancelToken = new AbortController();

  const urlParams = utils.createURL([
    { name: 'page', values: page },
    { name: 'limit', values: limit },
    { name: 'brand_ids', values: brand_ids },
    { name: 'item_ids', values: item_ids },
    { name: 'segments', values: segments },
    { name: 'log_user_ids', values: log_user_ids },
  ]);

  return {
    type: 'FETCH_CHANGE_LOGS_HISTORY',
    meta: { page },
    payload: axios.get(`${getNonGwApiRoot()}/change_logs/history${urlParams}`, {
      signal: fetchChangeLogsCancelToken.signal,
    }),
  };
}

export function fetchChangeLogItems(brand_ids: number[], keywords?: string) {
  if (fetchChangeLogItemsCancelToken) fetchChangeLogItemsCancelToken.abort();

  fetchChangeLogItemsCancelToken = new AbortController();

  const urlParams = utils.createURL([
    { name: 'brand_ids', values: brand_ids },
    { name: 'keywords', values: keywords },
  ]);

  return {
    type: 'FETCH_CHANGE_LOG_ITEMS',
    payload: axios.get(`${getNonGwApiRoot()}/change_logs/items${urlParams}`, {
      signal: fetchChangeLogItemsCancelToken.signal,
    }),
  };
}
